import { render, staticRenderFns } from "./turdetay.vue?vue&type=template&id=01f970b0"
import script from "./turdetay.vue?vue&type=script&lang=js"
export * from "./turdetay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports